(function(){
  'use strict';
  function desktop(){return window.matchMedia && window.matchMedia('(min-width:1025px)').matches;}

  function hoverDetails(el,others){
    if(!el || el.dataset.lbx96Hover==='1')return;
    el.dataset.lbx96Hover='1';
    var timer=0;
    function open(){
      if(!desktop())return;
      window.clearTimeout(timer);
      (others||[]).forEach(function(x){if(x&&x!==el)x.open=false;});
      el.open=true;
    }
    function close(){
      if(!desktop())return;
      window.clearTimeout(timer);
      timer=window.setTimeout(function(){
        if(!el.matches(':hover') && !el.contains(document.activeElement))el.open=false;
      },160);
    }
    el.addEventListener('mouseenter',open);
    el.addEventListener('mouseleave',close);
    el.addEventListener('focusin',open);
    el.addEventListener('focusout',close);
  }

  function initHeaderHover(){
    var locale=document.querySelector('.mg2-topbar [data-lbx91-locale]');
    var help=document.querySelector('[data-lbx95-desktop-help]');
    hoverDetails(locale,[help]);
    hoverDetails(help,[locale]);
  }

  function init(){initHeaderHover();}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  document.addEventListener('shopify:section:load',init);
})();
